import Social, { Platform } from "../social";

const Footer = () => {
  return (
    <footer className="w-full pb-10 mobile:pb-28 flex justify-center items-center text-white mobile:gap-5 flex-shrink-0 mobile:flex-col text-lg mobile:text-sm">
      <section className="flex items-center hidden mobile:inline">
        <div className="w-full flex flex-col justify-center items-center gap-3">
          {[Platform.INSTAGRAM, Platform.EMAIL].map((platform) => (
            <Social platform={platform} size={28} />
          ))}
        </div>
      </section>
      <div className="bg-main w-[50%] h-[0.5px] rounded-full hidden mobile:inline"></div>
      <section className="flex flex-row mobile:flex-col gap-2 mobile:gap-1justify-center items-center">
        <span>© {new Date().getFullYear()} Roberto Masanti.</span>
        <div className="flex flex-row gap-2">
          <span>Desarrollado por</span>
          <a
            href="https://vitessestack.com"
            className="hover:underline font-bold text-gold"
            target="blank_"
          >
            Vitessestack
          </a>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
